import { render } from "./shippingCreate.vue?vue&type=template&id=b42c8b5e&scoped=true"
import script from "./shippingCreate.vue?vue&type=script&lang=js"
export * from "./shippingCreate.vue?vue&type=script&lang=js"

import "./shippingCreate.vue?vue&type=style&index=0&id=b42c8b5e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b42c8b5e"]])

export default __exports__